import React from 'react'
import { LINK_HANDLE_GAP, LINK_HANDLE_R, MILESTONE_SIZE, ROW_H } from '../../lib/constants'

export interface MilestoneMarkerProps {
  x: number
  rowTop: number
  label: string
  critical: boolean
  completed: boolean
  selected: boolean
  shiftUp: boolean
  activityId: string
  /** Task 18: link handle only — a milestone has no duration to resize. */
  showHandles?: boolean
  onPointerEnter?: (e: React.PointerEvent) => void
  onPointerLeave?: () => void
  onClick?: (e: React.MouseEvent) => void
}

/** Diamond marker for `isMilestone` activities. Spec B §8.4. */
const MilestoneMarker: React.FC<MilestoneMarkerProps> = ({ x, rowTop, label, critical, completed, selected, shiftUp, activityId, showHandles, onPointerEnter, onPointerLeave, onClick }) => {
  const cy = rowTop + ROW_H / 2 - (shiftUp ? 4 : 0)
  const h = MILESTONE_SIZE / 2
  const points = `${x},${cy - h} ${x + h},${cy} ${x},${cy + h} ${x - h},${cy}`
  const handleRight = LINK_HANDLE_GAP + LINK_HANDLE_R
  const labelX = x + h + (showHandles ? handleRight + 6 : 6)
  return (
    <g data-bar data-milestone data-activity-id={activityId} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} onClick={onClick} className="cursor-pointer">
      <polygon points={points} className={critical ? 'fill-destructive' : 'fill-primary'} />
      {completed && (
        <path
          d={`M${x - h * 0.5} ${cy} l${h * 0.35} ${h * 0.35} l${h * 0.7} -${h * 0.7}`}
          className="fill-none stroke-white"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {selected && (
        <polygon
          points={`${x},${cy - h - 2} ${x + h + 2},${cy} ${x},${cy + h + 2} ${x - h - 2},${cy}`}
          className="fill-none stroke-primary stroke-2"
        />
      )}
      {showHandles && (
        <circle
          data-link-handle
          data-activity-id={activityId}
          cx={x + h + LINK_HANDLE_GAP}
          cy={cy}
          r={LINK_HANDLE_R}
          className="fill-background stroke-primary stroke-2 cursor-crosshair"
        />
      )}
      <text x={labelX} y={cy} dominantBaseline="middle" className="text-xs fill-foreground pointer-events-none select-none">{label}</text>
    </g>
  )
}

export default MilestoneMarker
